import React, { Component, Fragment } from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { TextField, Typography, Button, Tooltip, Grid, Box, Menu, MenuItem, CircularProgress } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import {
  FilterFrames,
  CreateNewFolder,
  GetApp,
  Save,
  DateRange,
  Home,
  Storefront,
  AccountBalance,
  Person,
  Map,
  LocationOn,
  PieChart,
  Search
} from "@material-ui/icons";
import LabeledTextField from "../../layout/LabeledTextField";
import CustomAcordion from "../../layout/CustomAcordion";
import HelpDialog from "../../layout/HelpDialog";
import { showDateInTextType } from "../../../services/utils/utils";
import filesService from "../../../services/docsService/filesService";
import adminService from "../../../services/adminService";
import fieldsData from "../../../services/docsService/fieldsData";
import { searchLotParcelFromAddress } from "../../../services/govMapApi";
import config from "../../../config";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { confirmTaxAuthorityDocumentGenerationOncePerDeal } from "../../shared/dialogs/taxAuthorityDocumentConfirm";
import {
  DOC_2990_AUTOFILL_TARGET_FIELDS,
  buildPropertyAutofillPatch,
  parseSmartLookupAddress,
  resolveHaklaiCatalogAddress
} from "../../haklai/results/form2990/haklai2990Helpers";
import {
  HAKLAI_2990_ACTIONS,
  HAKLAI_2990_LABELS,
  HAKLAI_2990_MESSAGES,
  HAKLAI_2990_SMART_ADDRESS_HELP,
  getHaklai2990ParcelChoiceLabel
} from "../../haklai/results/form2990/haklai2990Texts";

const FORM_FIELD_INPUT_WIDTH = 168;

const SMART_ADDRESS_HELP_DIALOG = (
  <Box textAlign="right">
    <Typography variant="body2" component="div" gutterBottom>
      {HAKLAI_2990_SMART_ADDRESS_HELP.formatsTitle}
    </Typography>
    <ul style={{ margin: "8px 0 0", paddingRight: "18px" }}>
      {HAKLAI_2990_SMART_ADDRESS_HELP.formats.map((format) => (
        <li key={format}>{format}</li>
      ))}
    </ul>
    <Typography variant="body2" component="div" style={{ marginTop: 12 }}>
      {HAKLAI_2990_SMART_ADDRESS_HELP.examplesTitle}
      {HAKLAI_2990_SMART_ADDRESS_HELP.examples.map((example) => (
        <React.Fragment key={example}>
          <br />
          {example}
        </React.Fragment>
      ))}
    </Typography>
  </Box>
);

class DealSumCalc extends Component {
  parcelMenuAnchorRef = React.createRef();
  parcelLookupReq = 0;

  state = {
    doc2990Fields: {},
    cities: null,
    streets: [],
    showDoc2990Fields: false,
    parcelAddressSearch: "",
    isAddressSearchLoading: false,
    parcelAddressError: "",
    isGovMapAutofill: false,
    addressChoices: [],
    addressMenuAnchor: null
  };

  componentDidMount() {
    filesService.getDocsFields(this.props.match.params.dealId, true).then((res) => {
      if (res.success) {
        const doc2990Fields = {
          ...res.data,
          sellerId: res.data.sellerId ? parseInt(res.data.sellerId) : null,
          blockNum: res.data.blockNum ? parseInt(res.data.blockNum) : null,
          subBlock: res.data.subBlock ? parseInt(res.data.subBlock) : null,
          subSubBlock: res.data.subSubBlock ? parseInt(res.data.subSubBlock) : null,
          assetStreetNumber: res.data.assetStreetNumber ? parseInt(res.data.assetStreetNumber) : null,
          assetZipcode: res.data.assetZipcode ? parseInt(res.data.assetZipcode) : null,
          assetHouseNum: res.data.assetHouseNum ? parseInt(res.data.assetHouseNum) : null,
          passPartMekarkeinMechane: res.data.passPartMekarkeinMechane ? parseInt(res.data.passPartMekarkeinMechane) : null,
          passPartMekarkeinMone: res.data.passPartMekarkeinMone ? parseInt(res.data.passPartMekarkeinMone) : null
        };
        this.setState({ doc2990Fields, showDoc2990Fields: true });
      }
    });
  }

  componentDidUpdate() {
    if (!this.state.cities) {
      if (this.props.addresses) {
        let cities = [];
        for (const curAddress of this.props.addresses) {
          if (!cities.includes(curAddress.cityName)) cities.push(curAddress.cityName);
        }
        this.setState({ cities });
      }
    }
  }

  render() {
    const mainCalc = this.props.mainCalc;
    const getTopValues = this.getTopValues();
    const actualPriceBought = this.getActualPriceBought();
    // const iahas = getTopValues.shoviRechishaLehishuvMas / actualPriceBought;
    // getTopValues.shoviMechiraLehishuvMas = this.props.preCalc.valueActualSoldOfProperty * iahas;

    const shevahReali11afterKizuz = Math.max(getTopValues.shevahReali11 - (mainCalc.kizuzHoni || 0) - (mainCalc.kizuzIski || 0), 0);

    const discountRabPercent = this.getMaximalRabinovich();
    const prisaData = mainCalc.prisa.shouldTryPrisa ? this.getPrisaData() : null;
    const preCalcPartsData = this.props.preCalc && this.props.preCalc.preCalcPartsData ? this.props.preCalc.preCalcPartsData : [];
    const summaryRows = this.getSummaryRows({
      shevahReali11: getTopValues.shevahReali11,
      shevahReali11afterKizuz,
      discountRabPercent,
      prisaData,
      isKizuzShown: Boolean(mainCalc.kizuzIski || mainCalc.kizuzHoni),
      isPrisaShown: Boolean(mainCalc.prisa.shouldTryPrisa),
      isAfkaaShown: Boolean(mainCalc.afkaa)
    });

    return (
      <Grid className="deal-sum-calc" container direction="column" spacing={2}>
        <Grid className="pre-calc-sections" container item direction="column" wrap="nowrap">
          <Grid item>
            <CustomAcordion summaryText="סיכום שומה" defaultExpanded={true}>
              <div className="deal-sum-facts">
                <section className="deal-sum-fact-section">
                  <h3 className="deal-sum-fact-section-title">
                    <span className="deal-sum-section-icon" aria-hidden="true">
                      <DateRange />
                    </span>
                    תאריכי העסקה
                  </h3>
                  <div className="deal-sum-fact-list">
                    {this.renderFactBadge("יום המכירה", showDateInTextType(this.props.preCalc.soldPropertyDate))}
                    {this.renderFactBadge("יום הרכישה", showDateInTextType(this.getBoughtDate()))}
                  </div>
                </section>

                <div className="deal-sum-facts-row">
                  <section className="deal-sum-fact-section">
                    <h3 className="deal-sum-fact-section-title">
                      <span className="deal-sum-section-icon" aria-hidden="true">
                        <Home />
                      </span>
                      פרטי רכישה
                    </h3>
                    <div className="deal-sum-fact-list">
                      {this.renderFactBadge("שווי הרכישה", this.formatFactAmount(actualPriceBought))}
                      {this.renderFactBadge("שווי רכישה לחישוב מס", this.formatFactAmount(getTopValues.shoviRechishaLehishuvMas))}
                      {this.renderFactBadge("שווי רכישה לחישוב מס מתואם", this.formatFactAmount(getTopValues.shoviRechisaMasMetoam))}
                    </div>
                  </section>

                  <section className="deal-sum-fact-section">
                    <h3 className="deal-sum-fact-section-title">
                      <span className="deal-sum-section-icon" aria-hidden="true">
                        <Storefront />
                      </span>
                      פרטי מכירה
                    </h3>
                    <div className="deal-sum-fact-list">
                      {this.renderFactBadge("שווי המכירה", this.formatFactAmount(this.props.preCalc.valueActualSoldOfProperty))}
                      {this.renderFactBadge("שווי מכירה חייב במס", this.formatFactAmount(getTopValues.shoviMechiraHaiavMas))}
                    </div>
                  </section>
                </div>

                {mainCalc.kizuzIski || mainCalc.kizuzHoni ? (
                  <section className="deal-sum-fact-section">
                    <h3 className="deal-sum-fact-section-title">קיזוז הפסדים</h3>
                    <div className="deal-sum-fact-list">
                      {this.renderFactBadge("קיזוז הפסדים עסקי, מועבר ושוטף", this.formatFactAmount(mainCalc.kizuzIski || 0), "is-accent")}
                      {this.renderFactBadge("קיזוז הפסדים הוני", this.formatFactAmount(mainCalc.kizuzHoni || 0), "is-accent")}
                    </div>
                  </section>
                ) : null}

                {mainCalc.prisa.shouldTryPrisa ? (
                  <section className="deal-sum-fact-section">
                    <h3 className="deal-sum-fact-section-title">פריסה</h3>
                    <div className="deal-sum-fact-list">
                      {this.renderFactBadge("תקופת פריסה מומלצת", this.formatFactAmount(prisaData.maxPrisaYearsAllowed), "is-accent")}
                      {this.renderFactBadge("סך חיסכון בגין פריסה", this.formatFactAmount(prisaData.totalPrisaRev), "is-accent")}
                    </div>
                  </section>
                ) : null}

                <section className="deal-sum-totals">
                  <h3 className="deal-sum-fact-section-title">
                    <span className="deal-sum-section-icon" aria-hidden="true">
                      <AccountBalance />
                    </span>
                    סיכום מס
                  </h3>
                  <div className="deal-sum-totals-list">
                    {summaryRows.map((row) => (
                      <Fragment key={row.label}>
                        {row.isFinal ? <div className="deal-sum-totals-break" aria-hidden="true" /> : null}
                        <div className={`deal-sum-total-row${row.isFinal ? " is-final" : ""}`}>
                          <span className="deal-sum-total-label">{row.label}</span>
                          <span className="deal-sum-total-value">{row.value}</span>
                        </div>
                      </Fragment>
                    ))}
                  </div>
                </section>
              </div>
            </CustomAcordion>
          </Grid>

          {this.state.showDoc2990Fields ? (
            <Grid item>
              <CustomAcordion summaryText="מילוי פרטים אישיים לטופס 2990" defaultExpanded={true}>
                <div className="deal-sum-form">
                  {this.renderPropertyAddressLookup()}
                  <div className="deal-sum-form-row">
                  <section className="deal-sum-fact-section">
                    <h3 className="deal-sum-fact-section-title">
                      <span className="deal-sum-section-icon" aria-hidden="true">
                        <Person />
                      </span>
                      פרטי המוכר
                    </h3>
                    {this.renderFormFieldTable([
                      {
                        label: "שם פרטי",
                        field: (
                          <LabeledTextField
                            type="text"
                            value={this.state.doc2990Fields.sellerFirstName}
                            name="sellerFirstName"
                            maxLength="17"
                            textFieldWidth={FORM_FIELD_INPUT_WIDTH}
                            onChange={this.handleOnChange}
                          />
                        )
                      },
                      {
                        label: "שם משפחה",
                        field: (
                          <LabeledTextField
                            type="text"
                            value={this.state.doc2990Fields.sellerLastName}
                            name="sellerLastName"
                            maxLength="17"
                            textFieldWidth={FORM_FIELD_INPUT_WIDTH}
                            onChange={this.handleOnChange}
                          />
                        )
                      },
                      {
                        label: "מספר זהות",
                        field: (
                          <Tooltip
                            title="במידה ומדובר בתושב חוץ ללא תעודת זהות, יש לפנות לרשות על מנת לקבל מספר רישוי מיוחד שלהם שישמש לעסקה"
                            placement="bottom-start"
                          >
                            <div>
                              <LabeledTextField
                                type="number"
                                value={this.state.doc2990Fields.sellerId}
                                name="sellerId"
                                maxLength="9"
                                noComma
                                sequencesOfZerosAllowed
                                textFieldWidth={FORM_FIELD_INPUT_WIDTH}
                                onChange={this.handleOnChange}
                              />
                            </div>
                          </Tooltip>
                        )
                      }
                    ])}
                  </section>

                  <section className="deal-sum-fact-section">
                    <h3 className="deal-sum-fact-section-title">
                      <span className="deal-sum-section-icon" aria-hidden="true">
                        <AccountBalance />
                      </span>
                      משרד מיסוי מקרקעין
                    </h3>
                    {this.renderFormFieldTable([
                      {
                        label: "מקום המשרד",
                        field: (
                          <LabeledTextField
                            type="select"
                            options={fieldsData.lishcatRishumLocation.options}
                            onChange={this.handleOnChange}
                            value={this.state.doc2990Fields.lishcatRishumLocation}
                            name="lishcatRishumLocation"
                            textFieldWidth={FORM_FIELD_INPUT_WIDTH}
                          />
                        )
                      }
                    ])}
                  </section>
                  </div>

                  <div className="deal-sum-form-row">
                  <section className="deal-sum-fact-section">
                    <h3 className="deal-sum-fact-section-title">
                      <span className="deal-sum-section-icon" aria-hidden="true">
                        <Map />
                      </span>
                      זיהוי הנכס
                    </h3>
                    {this.renderFormFieldTable([
                      {
                        label: "גוש",
                        field: (
                          <LabeledTextField
                            type="number"
                            noComma
                            maxLength="6"
                            textFieldWidth={FORM_FIELD_INPUT_WIDTH}
                            value={this.state.doc2990Fields.blockNum}
                            name="blockNum"
                            onChange={this.handleOnChange}
                          />
                        )
                      },
                      {
                        label: "חלקה",
                        field: (
                          <LabeledTextField
                            type="number"
                            noComma
                            maxLength="4"
                            textFieldWidth={FORM_FIELD_INPUT_WIDTH}
                            value={this.state.doc2990Fields.subBlock}
                            name="subBlock"
                            onChange={this.handleOnChange}
                          />
                        )
                      },
                      {
                        label: "תת חלקה",
                        field: (
                          <LabeledTextField
                            type="number"
                            noComma
                            maxLength="3"
                            textFieldWidth={FORM_FIELD_INPUT_WIDTH}
                            value={this.state.doc2990Fields.subSubBlock}
                            name="subSubBlock"
                            onChange={this.handleOnChange}
                          />
                        )
                      }
                    ])}
                  </section>

                  <section className="deal-sum-fact-section">
                    <h3 className="deal-sum-fact-section-title">
                      <span className="deal-sum-section-icon" aria-hidden="true">
                        <PieChart />
                      </span>
                      החלק הנמכר
                    </h3>
                    <div className="deal-sum-fraction-wrap">
                      <div className="deal-sum-fraction">
                        <LabeledTextField
                          type="number"
                          noComma
                          maxLength="12"
                          textFieldWidth={72}
                          value={this.state.doc2990Fields.passPartMekarkeinMechane}
                          name="passPartMekarkeinMechane"
                          label="מכנה החלק הנמכר"
                          onChange={this.handleOnChange}
                        />
                        <div className="deal-sum-fraction-slash">/</div>
                        <LabeledTextField
                          type="number"
                          noComma
                          maxLength="12"
                          textFieldWidth={72}
                          value={this.state.doc2990Fields.passPartMekarkeinMone}
                          name="passPartMekarkeinMone"
                          label="מונה החלק הנמכר"
                          onChange={this.handleOnChange}
                        />
                      </div>
                      <div className="deal-sum-fraction-hint">לדוגמה: 5/23, 1/1, 1/2</div>
                    </div>
                  </section>
                  </div>

                  <div className="deal-sum-form-row is-wide">
                  <section className="deal-sum-fact-section">
                    <h3 className="deal-sum-fact-section-title">
                      <span className="deal-sum-section-icon" aria-hidden="true">
                        <LocationOn />
                      </span>
                      כתובת הנכס
                    </h3>
                    <div className="deal-sum-address-grid">
                      {this.renderFormFieldTable([
                        {
                          label: "עיר הנכס",
                          field: (
                            <Autocomplete
                              blurOnSelect
                              options={this.state.cities ? this.state.cities : []}
                              openOnFocus
                              freeSolo
                              inputValue={this.state.doc2990Fields.assetCity || ""}
                              renderInput={(params) => (
                                <TextField {...params} variant="outlined" size="small" style={{ width: FORM_FIELD_INPUT_WIDTH }} />
                              )}
                              onInputChange={(e, val, reason) => {
                                if (reason === "reset") return;
                                this.handleOnChange({ target: { name: "assetCity", value: val } });
                              }}
                              onChange={(e, val) => this.onCityChange(val)}
                            />
                          )
                        },
                        {
                          label: "רחוב הנכס",
                          field: (
                            <Autocomplete
                              blurOnSelect
                              options={this.state.streets}
                              openOnFocus
                              freeSolo
                              inputValue={this.state.doc2990Fields.assetStreet || ""}
                              renderInput={(params) => (
                                <TextField {...params} variant="outlined" size="small" style={{ width: FORM_FIELD_INPUT_WIDTH }} />
                              )}
                              onInputChange={(e, val, reason) => {
                                if (reason === "reset") return;
                                this.handleOnChange({ target: { name: "assetStreet", value: val } });
                              }}
                              onChange={(e, val) => this.handleOnChange({ target: { name: "assetStreet", value: val } })}
                            />
                          )
                        },
                        {
                          label: "מספר בית",
                          field: (
                            <LabeledTextField
                              value={this.state.doc2990Fields.assetStreetNumber}
                              name="assetStreetNumber"
                              type="number"
                              maxLength="5"
                              noComma
                              textFieldWidth={FORM_FIELD_INPUT_WIDTH}
                              onChange={this.handleOnChange}
                            />
                          )
                        }
                      ])}
                      {this.renderFormFieldTable([
                        {
                          label: "מספר דירה",
                          field: (
                            <LabeledTextField
                              value={this.state.doc2990Fields.assetHouseNum}
                              name="assetHouseNum"
                              type="number"
                              maxLength="4"
                              noComma
                              textFieldWidth={FORM_FIELD_INPUT_WIDTH}
                              onChange={this.handleOnChange}
                            />
                          )
                        },
                        {
                          label: "מיקוד הנכס",
                          field: (
                            <LabeledTextField
                              value={this.state.doc2990Fields.assetZipcode}
                              name="assetZipcode"
                              type="number"
                              noComma
                              textFieldWidth={FORM_FIELD_INPUT_WIDTH}
                              maxLength="7"
                              onChange={this.handleOnChange}
                            />
                          )
                        }
                      ])}
                    </div>
                  </section>
                  </div>

                  <div className="deal-sum-form-actions">
                    <Button
                      className="pre-calc-results-expand"
                      variant="outlined"
                      endIcon={<Save style={{ marginRight: "8px" }} />}
                      onClick={this.savePersonalDetailsOf2990}
                    >
                      שמור פרטים אישיים
                    </Button>
                  </div>
                </div>
              </CustomAcordion>
            </Grid>
          ) : null}

          <Grid item>
            <CustomAcordion summaryText="הפקת מסמכים" defaultExpanded={true}>
              <div className="deal-sum-docs">
                <div className="deal-sum-docs-block">
                  <Typography variant="subtitle1" align="right">
                    פעולות נוספות
                  </Typography>
                  <div className="deal-sum-action-buttons">
                    <Button
                      className="deal-sum-admin-btn"
                      variant="outlined"
                      endIcon={<CreateNewFolder style={{ marginRight: "8px" }} />}
                      onClick={this.generate2990}
                    >
                      הפק טופס 2990
                    </Button>
                    <Button
                      className="deal-sum-admin-btn"
                      variant="outlined"
                      endIcon={<CreateNewFolder style={{ marginRight: "8px" }} />}
                      onClick={this.generateDeductions}
                    >
                      הפק טופס ניכויים
                    </Button>
                    {this.props.role === "admin" ? (
                      <Fragment>
                        <Button
                          className="deal-sum-admin-btn"
                          variant="outlined"
                          endIcon={<FilterFrames style={{ marginRight: "8px" }} />}
                          onClick={this.addDealTest}
                        >
                          שמירה כטסט
                        </Button>
                        <Button
                          className="deal-sum-admin-btn"
                          variant="outlined"
                          endIcon={<GetApp style={{ marginRight: "8px" }} />}
                          onClick={() => this.props.exportDealData()}
                        >
                          ייצא
                        </Button>
                      </Fragment>
                    ) : null}
                  </div>
                </div>
                <div className="deal-sum-docs-block">
                  <Typography variant="subtitle1" align="right">
                    הפקת קבצים מקוונים לרשות המיסים
                  </Typography>
                  <div className="deal-sum-file-buttons">
                    {preCalcPartsData.map((currentPart, index) => (
                      <div className="deal-sum-file-group" key={"part" + index}>
                        {preCalcPartsData.length > 1 ? (
                          <div className="deal-sum-file-group-title">עסקה מספר - {index + 1}</div>
                        ) : null}
                        <div className="deal-sum-file-buttons">
                          {currentPart.needsMutav ? (
                            <Button
                              className="deal-sum-primary-btn"
                              onClick={() => this.generate2990Json("mutav", index)}
                              endIcon={<GetApp style={{ marginRight: "8px" }} />}
                              variant="contained"
                            >
                              קובץ מס מוטב
                            </Button>
                          ) : null}
                          {currentPart.needsRegTax ? (
                            <Button
                              className="deal-sum-primary-btn"
                              onClick={() => this.generate2990Json("linear", index)}
                              endIcon={<GetApp style={{ marginRight: "8px" }} />}
                              variant="contained"
                            >
                              קובץ לינארי ישן
                            </Button>
                          ) : null}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </CustomAcordion>
          </Grid>
        </Grid>

        <Grid item>
          <Box className="pre-calc-results-note">
            נכון לשנת 2025, יחיד אשר הכנסתו החייבת (כולל שבח מקרקעין) תעלה על 721,560 ש"ח, יהיה חייב במס נוסף (מס יסף) על כל שקל נוסף בשיעור
            של 3%. מס יסף יחול בגין שבח ממכירת זכות במקרקעין המהווה דירת מגורים במידה ושווי מכירתה מעל 5,382,285 ש"ח והמכירה אינה פטורה ממס
            לפי כל דין. "הכנסה חייבת" – כהגדרתה בסעיף 121ב לפקודת מס הכנסה. ראה הוראת ביצוע 9/15 רשות המיסים. בהתאם לחוק ההתייעלות הכלכלית
            התשפ"ה 2024, נוסף על האמור לעיל, יחיד אשר הכנסתו החייבת ממקורות הוניים בשנת המס עלתה על הסכום של 721,560 ש"ח, יהיה חייב במס נוסף
            על חלק הכנסתו החייבת ממקורות הוניים העולה על הסכום האמור, בשיעור של 2%.
            <br />
            "הכנסה חייבת" – כהגדרתה בסעיף 121ב לפקודת מס הכנסה. ראה הוראת ביצוע 9/15 רשות המיסים.
          </Box>
        </Grid>
      </Grid>
    );
  }

  getSummaryRows({ shevahReali11, shevahReali11afterKizuz, discountRabPercent, prisaData, isKizuzShown, isPrisaShown, isAfkaaShown }) {
    const rows = [{ label: 'סה"כ שבח בעסקה', value: this.formatSumAmount(shevahReali11) }];
    if (isKizuzShown) {
      rows.push({ label: 'סה"כ שבח לאחר קיזוז הפסדים', value: this.formatSumAmount(shevahReali11afterKizuz) });
    }
    rows.push({ label: 'סה"כ מס שבח', value: this.formatSumAmount(this.getFinalMasShevahPrePrisa()) });
    if (discountRabPercent) {
      rows.push({ label: "הנחת רבינוביץ", value: `${discountRabPercent * 100}%` });
    }
    if (isPrisaShown) {
      rows.push({ label: 'סה"כ מס שבח לאחר פריסה', value: this.formatSumAmount(prisaData.totalPreAfkaa) });
    }
    if (isAfkaaShown) {
      rows.push({ label: "זיכוי הפקעה", value: this.formatSumAmount(this.getAfterAfkaa()) });
    }
    rows.push({ label: 'סה"כ מס לתשלום', value: this.formatSumAmount(this.getFinalTax()), isFinal: true });
    return rows;
  }

  renderFormFieldTable(rows) {
    return (
      <table className="deal-sum-field-table">
        <tbody>
          {rows.map((row) => (
            <tr key={row.label}>
              <th>{row.label}</th>
              <td>{row.field}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  renderFactBadge(label, value, variant) {
    const variantClass = variant ? ` ${variant}` : "";
    return (
      <div className={`deal-sum-fact-badge${variantClass}`} key={label}>
        <span className="deal-sum-fact-label">{label}</span>
        <span className="deal-sum-fact-value">{value}</span>
      </div>
    );
  }

  formatFactAmount(amount) {
    if (typeof amount === "string") return amount;
    if (!Number.isFinite(amount)) return "0";
    return amount.toLocaleString(undefined, { maximumFractionDigits: 2 });
  }

  formatSumAmount(amount) {
    if (typeof amount === "string") return amount;
    if (!Number.isFinite(amount)) return "0";
    return amount.toLocaleString(undefined, { maximumFractionDigits: 0 });
  }

  renderPropertyAddressLookup() {
    const { parcelAddressSearch, isAddressSearchLoading, parcelAddressError, isGovMapAutofill, addressChoices, addressMenuAnchor } = this.state;

    return (
      <section className="deal-sum-fact-section deal-sum-lookup">
        <h3 className="deal-sum-fact-section-title">
          <span className="deal-sum-section-icon" aria-hidden="true">
            <LocationOn />
          </span>
          {HAKLAI_2990_LABELS.propertyLookup}
          <HelpDialog
            label={HAKLAI_2990_LABELS.propertyLookup}
            helpDialog={SMART_ADDRESS_HELP_DIALOG}
          />
        </h3>
        <div className="deal-sum-lookup-bar" ref={this.parcelMenuAnchorRef}>
          <TextField
            className="deal-sum-lookup-input"
            name="parcelAddressSearch"
            onChange={this.handleParcelSearchChange}
            onKeyPress={this.handleAddressKeyPress}
            placeholder={HAKLAI_2990_SMART_ADDRESS_HELP.placeholder}
            size="small"
            value={parcelAddressSearch}
            variant="outlined"
          />
          <Button
            className="deal-sum-primary-btn deal-sum-lookup-search"
            disabled={isAddressSearchLoading || !String(parcelAddressSearch || "").trim()}
            onClick={this.handleAddressSearchClick}
            endIcon={isAddressSearchLoading ? <CircularProgress color="inherit" size={16} style={{ marginRight: "8px" }} /> : <Search style={{ marginRight: "8px" }} />}
          >
            {HAKLAI_2990_ACTIONS.searchPropertyDetails}
          </Button>
        </div>
        {parcelAddressError ? (
          <Typography variant="caption" component="div" className="deal-sum-lookup-message is-error">
            {parcelAddressError}
          </Typography>
        ) : isGovMapAutofill ? (
          <Typography variant="caption" component="div" className="deal-sum-lookup-message is-success">
            {HAKLAI_2990_MESSAGES.smartAddressAutofill}
          </Typography>
        ) : null}
        <Menu
          anchorEl={addressMenuAnchor}
          open={Boolean(addressMenuAnchor) && addressChoices.length > 1}
          onClose={this.closeAddressParcelMenu}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          getContentAnchorEl={null}
        >
          {addressChoices.map((pair) => (
            <MenuItem
              key={`${pair.gush}-${pair.helka}-${pair.objectId != null ? pair.objectId : ""}`}
              onClick={() => this.handleAddressChoiceClick(pair)}
            >
              {getHaklai2990ParcelChoiceLabel(pair)}
            </MenuItem>
          ))}
        </Menu>
      </section>
    );
  }

  getStreetsForCity(cityName) {
    if (!cityName || !this.props.addresses) return [];
    return this.props.addresses.filter((x) => x.cityName === cityName).map((x) => x.streetName);
  }

  closeAddressParcelMenu = () => {
    this.setState({
      addressMenuAnchor: null,
      addressChoices: []
    });
  };

  handleParcelSearchChange = (e) => {
    this.parcelLookupReq += 1;
    this.setState({
      parcelAddressSearch: e.target.value,
      parcelAddressError: "",
      isGovMapAutofill: false,
      isAddressSearchLoading: false,
      addressChoices: [],
      addressMenuAnchor: null
    });
  };

  handleAddressKeyPress = (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    this.handleAddressSearchClick();
  };

  applyAddressAutofill = (patch) => {
    this.setState((prev) => ({
      doc2990Fields: {
        ...prev.doc2990Fields,
        ...patch
      },
      streets: patch.assetCity ? this.getStreetsForCity(patch.assetCity) : prev.streets,
      parcelAddressSearch: "",
      parcelAddressError: "",
      isGovMapAutofill: true,
      isAddressSearchLoading: false,
      addressChoices: [],
      addressMenuAnchor: null
    }));
  };

  getResolvedAutofillPatch = (lot, parcel, parsedAddress) => {
    const catalogAddress = resolveHaklaiCatalogAddress(parsedAddress, this.props.addresses || []);
    return buildPropertyAutofillPatch({
      lot,
      parcel,
      resolvedAddress: catalogAddress,
      parsedAddress
    });
  };

  handleAddressSearchClick = async () => {
    const trimmedAddress = String(this.state.parcelAddressSearch || "").trim();
    const parsedAddress = parseSmartLookupAddress(trimmedAddress);
    if (!parsedAddress) {
      this.parcelLookupReq += 1;
      this.setState({
        isAddressSearchLoading: false,
        isGovMapAutofill: false,
        addressChoices: [],
        addressMenuAnchor: null,
        parcelAddressError: HAKLAI_2990_MESSAGES.smartAddressFormatError
      });
      return;
    }

    const govMapCredential = config.govMapApiToken;
    if (!govMapCredential || !String(govMapCredential).trim()) {
      this.parcelLookupReq += 1;
      this.setState({
        isAddressSearchLoading: false,
        parcelAddressError: HAKLAI_2990_MESSAGES.govMapUnavailable
      });
      return;
    }

    const req = ++this.parcelLookupReq;
    this.setState({
      isAddressSearchLoading: true,
      isGovMapAutofill: false,
      parcelAddressError: "",
      addressChoices: [],
      addressMenuAnchor: null
    });

    try {
      const pairs = await searchLotParcelFromAddress(govMapCredential, parsedAddress.lookupAddress);
      if (req !== this.parcelLookupReq) return;

      if (!pairs.length) {
        this.setState({
          isAddressSearchLoading: false,
          parcelAddressError: HAKLAI_2990_MESSAGES.addressNoMatch
        });
        return;
      }

      if (pairs.length === 1) {
        this.applyAddressAutofill(this.getResolvedAutofillPatch(pairs[0].gush, pairs[0].helka, parsedAddress));
        return;
      }

      this.setState({
        isAddressSearchLoading: false,
        addressChoices: pairs,
        addressMenuAnchor: this.parcelMenuAnchorRef.current
      });
    } catch {
      if (req !== this.parcelLookupReq) return;
      this.setState({
        isAddressSearchLoading: false,
        parcelAddressError: HAKLAI_2990_MESSAGES.addressSearchFailed
      });
    }
  };

  handleAddressChoiceClick = (pair) => {
    const parsedAddress = parseSmartLookupAddress(this.state.parcelAddressSearch);
    this.applyAddressAutofill(this.getResolvedAutofillPatch(pair.gush, pair.helka, parsedAddress));
  };

  onCityChange(newCity) {
    this.handleOnChange({ target: { name: "assetCity", value: newCity } });

    this.setState({ streets: this.getStreetsForCity(newCity) });
  }

  savePersonalDetailsOf2990 = () => {
    filesService.update2990SpecificFields(this.props.match.params.dealId, this.state.doc2990Fields).then((res) => {
      if (res.success) {
        Swal.fire("נתונים נשמרו בהצלחה", "", "success");
      }
    });
  };

  handleOnChange = (e) => {
    const fieldName = e.target.name;
    const doc2990Fields = { ...this.state.doc2990Fields, [fieldName]: e.target.value };
    const nextState = { doc2990Fields };

    if (DOC_2990_AUTOFILL_TARGET_FIELDS.includes(fieldName) && this.state.isGovMapAutofill) {
      nextState.isGovMapAutofill = false;
    }

    this.setState(nextState);
  };

  confirmTaxAuthorityDocumentGeneration = async () => {
    return confirmTaxAuthorityDocumentGenerationOncePerDeal({
      dealId: this.props.match.params.dealId,
      fullName: this.props.fullName,
      licenseNumber: this.props.licenseNumber,
      disableTaxAuthorityDocumentConfirmation: this.props.disableTaxAuthorityDocumentConfirmation
    });
  };

  generate2990 = async () => {
    const confirmed = await this.confirmTaxAuthorityDocumentGeneration();
    if (!confirmed) {
      return;
    }

    const dataForGenerate2990Doc = { ...this.state.doc2990Fields };
    dataForGenerate2990Doc.dealId = this.props.match.params.dealId;

    filesService.generate2990(dataForGenerate2990Doc).catch(() => {
      Swal.fire("היתה בעיה ביצירת המסמך", "במידה ובעיה זו ממשיכה בבקשה צרו איתנו קשר", "warning");
    });
  };

  generateDeductions = async () => {
    const confirmed = await this.confirmTaxAuthorityDocumentGeneration();
    if (!confirmed) {
      return;
    }

    filesService.generateDeductions(this.props.match.params.dealId).catch(() => {
      Swal.fire("היתה בעיה ביצירת המסמך", "במידה ובעיה זו ממשיכה בבקשה צרו איתנו קשר", "warning");
    });
  };

  generate2990Json = async (dealTaxType, dealIndex) => {
    const dataForGenerate2990Doc = { ...this.state.doc2990Fields };
    dataForGenerate2990Doc.dealId = this.props.match.params.dealId;

    const passPartMekarkeinMechaneParsed = parseFloat(dataForGenerate2990Doc.passPartMekarkeinMechane);
    const passPartMekarkeinMoneParsed = parseFloat(dataForGenerate2990Doc.passPartMekarkeinMechane);

    if (!Number.isInteger(passPartMekarkeinMechaneParsed) || !Number.isInteger(passPartMekarkeinMoneParsed)) {
      return Swal.fire("מונה ומכנה חייבים להיות מספרים שלמים", "", "warning");
    }

    if (passPartMekarkeinMechaneParsed <= 0 || passPartMekarkeinMoneParsed <= 0) {
      return Swal.fire("מונה ומכנה חייבים להיות גדולים מאפס", "", "warning");
    }

    if (
      (!dataForGenerate2990Doc.sellerFirstName && dataForGenerate2990Doc.sellerFirstName !== "") ||
      (!dataForGenerate2990Doc.sellerLastName && dataForGenerate2990Doc.sellerLastName !== "") ||
      !dataForGenerate2990Doc.lishcatRishumLocation ||
      !dataForGenerate2990Doc.sellerId ||
      (!dataForGenerate2990Doc.blockNum && dataForGenerate2990Doc.blockNum !== 0) ||
      (!dataForGenerate2990Doc.subBlock && dataForGenerate2990Doc.subBlock !== 0) ||
      (!dataForGenerate2990Doc.assetStreet && dataForGenerate2990Doc.assetStreet !== "") ||
      (!dataForGenerate2990Doc.assetStreetNumber && dataForGenerate2990Doc.assetStreetNumber !== "")
    ) {
      return Swal.fire("חלק מנתוני הטופס המקוון לא הוזנו. לא ניתן להגיש טופס כך לרשות", "", "warning");
    }

    if (dataForGenerate2990Doc.sellerId.length < 9) {
      return Swal.fire("ת.ז לא חוקית", "", "warning");
    }

    if (parseInt(dataForGenerate2990Doc.subBlock) > 9999 || parseInt(dataForGenerate2990Doc.subBlock) < 0) {
      return Swal.fire("חלקה חייב להיות בין 0 ל-9999", "", "warning");
    }

    filesService.generate2990Json(dataForGenerate2990Doc, dealTaxType, dealIndex, this.props.preCalc.preCalcPartsData.length).catch(() => {
      Swal.fire("היתה בעיה ביצירת המסמך", "במידה ובעיה זו ממשיכה בבקשה צרו איתנו קשר", "warning");
    });
    filesService.update2990SpecificFields(this.props.match.params.dealId, this.state.doc2990Fields);
  };

  addDealTest = () => {
    Swal.fire({
      title: "הזן תיאור בדיקה",
      input: "text",
      showCancelButton: true,
      cancelButtonText: "ביטול",
      confirmButtonText: "המשך",
      preConfirm: (testDescription) => {
        if (!testDescription) return Swal.showValidationMessage("יש להזין תיאור בדיקה");
        return adminService
          .addDealTest(testDescription, { preCalc: this.props.preCalc, mainCalc: this.props.mainCalc }, "btax")
          .then((res) => res)
          .catch((e) => Swal.showValidationMessage(`בקשה נדחתה: ${e}`));
      }
    }).then((result) => {
      if (result.isConfirmed && result.value.success) {
        Swal.fire({
          icon: "success",
          title: `הבדיקה נשמרה בהצלחה`,
          confirmButtonText: "המשך"
        });
      }
    });
  };

  getBoughtDate() {
    let minDate = moment(new Date()).format("YYYY-MM-DD");
    for (const deduction of this.props.mainCalc.deductions) {
      if (deduction.deduType === "purchase" || deduction.deduType === "gift") {
        if (minDate > deduction.deduDate) {
          minDate = deduction.deduDate;
        }
      } else if (deduction.deduType === "inheritance") {
        const tempDate = this.props.getPurchaseDate(deduction);
        if (minDate > tempDate) {
          minDate = tempDate;
        }
      }
    }
    return minDate;
  }

  getActualPriceBought() {
    let totalBought = 0;
    for (const part of this.props.mainCalc.calculatedData.deductionMat) {
      // totalBought += part[0].amount;
      totalBought += part[0].amountAfterCurrencyConversion || 0;
    }
    return totalBought;
  }

  getTopValues() {
    const topValues = { shevahReali11: 0, shoviRechishaLehishuvMas: 0, shoviMechiraHaiavMas: 0, shoviRechisaMasMetoam: 0 };
    for (const part of this.props.mainCalc.calculatedData.dataPerPart) {
      topValues.shevahReali11 += (part.shevahRealiMutav11 || 0) + (part.shevahRealiRegTax11 || 0);
      topValues.shoviRechishaLehishuvMas += part.sumAmountMutav + part.sumAmountRegTax;
      topValues.shoviMechiraHaiavMas += part.baseDeltaMasMutav + part.zabanMasMutavToPay + part.baseDeltaRegTax + part.zabanMasRegToPay;
      topValues.shoviRechisaMasMetoam += part.sumMemudadMutav + part.sumMemudadRegTax;
    }

    return topValues;
  }

  getFinalMasShevahPrePrisa() {
    if (this.props.mainCalc.prisa.shouldTryPrisa) {
      return this.props.mainCalc.calculatedData.dataPerPart.reduce(
        (a, b) =>
          a +
          (b.finalLinearBeforePrisa20 || 0) +
          (b.finalLinearBeforePrisa25 || 0) +
          (b.finalLinearBeforePrisa47 || 0) +
          (b.finalMutavBeforePrisa25 || 0) +
          (b.finalInflationLinear10 || 0),
        0
      );
    } else {
      return this.props.mainCalc.calculatedData.dataPerPart.reduce(
        (a, b) => a + (b.finalLinearTaxAllPreAfkaa21 || 0) + (b.finalMutavTaxAllPreAfkaa21 || 0),
        0
      );
    }
  }

  getMaximalRabinovich() {
    return this.props.mainCalc.calculatedData.dataPerPart.reduce((a, b) => Math.max(a, b.discountRabPercent || 0), 0);
  }

  getPrisaData() {
    let totalPrisaRev = 0,
      maxPrisaYearsAllowed = 0,
      totalPreAfkaa = 0;

    for (const part of this.props.mainCalc.calculatedData.dataPerPart) {
      maxPrisaYearsAllowed = Math.max(part.prisaData[0].length, maxPrisaYearsAllowed);

      totalPrisaRev += part.finalLinearBeforePrisa47 - part.finalLinear47;
      totalPrisaRev += part.finalMutavBeforePrisa25 - part.finalMutav25;
      totalPrisaRev += part.finalLinearBeforePrisa25 - part.finalLinear25;
      totalPrisaRev += part.finalLinearBeforePrisa20 - part.finalLinear20;

      totalPreAfkaa += (part.finalLinearTaxAllPreAfkaa21 || 0) + (part.finalMutavTaxAllPreAfkaa21 || 0);
    }
    return { totalPrisaRev, maxPrisaYearsAllowed, totalPreAfkaa };
  }

  getAfterAfkaa() {
    return this.props.mainCalc.calculatedData.dataPerPart.reduce(
      (a, b) => a + (b.finalLinearTaxAll24 || 0) + (b.finalMutavTaxAll24 || 0),
      0
    );
  }

  getFinalTax() {
    return this.props.mainCalc.calculatedData.dataPerPart.reduce(
      (a, b) => a + (b.actualFinalLinear26 || 0) + (b.actualFinalMutav26 || 0),
      0
    );
  }
}

const mapStateToProps = (state) => {
  return {
    role: state.loggedinReducer.role,
    fullName: state.loggedinReducer.fullName,
    licenseNumber: state.loggedinReducer.licenseNumber,
    disableTaxAuthorityDocumentConfirmation: state.loggedinReducer.disableTaxAuthorityDocumentConfirmation
  };
};

export default withRouter(connect(mapStateToProps)(DealSumCalc));
